import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseHttpService } from './base.service';
import { ValidateIBANResponse, ValidateUserResponse } from '../models/beneficiary.model';

@Injectable({
    providedIn: 'root'
})
export class UtilsService extends BaseHttpService {

    private apiURL = `${environment.baseAPIUrl}/v1/utilities`;
    loading$ = new BehaviorSubject<boolean>(false);

    ValidateIBAN(body): Observable<ValidateIBANResponse> {
        let params = new HttpParams();
        if (body) {
            const keys = Object.keys(body);
            keys.forEach(key => params = params.append(key, body[key]));
        }
        return this.get(`${this.apiURL}/validate-iban`, params);
    }

    CheckIfHalaUser(body): Observable<ValidateUserResponse> {
        let params = new HttpParams();
        if (body) {
            const keys = Object.keys(body);
            keys.forEach(key => params = params.append(key, body[key]));
        }
        return this.get(`${this.apiURL}/IsUserExists`, params);
    }
    showLoader() {
        this.loading$.next(true);
    }

    hideLoader() {
        this.loading$.next(false);
    }
}
